import {
	matchPath,
} from 'react-router-dom'

import {
	PAGE_TITLES,
} from '../config'

export const getPageTitle = (pathname: string): string => {
	if (PAGE_TITLES[pathname]) {
		return PAGE_TITLES[pathname]
	}

	for (const [pattern, title] of Object.entries(PAGE_TITLES)) {
		if (matchPath(pattern, pathname)) {
			return title
		}
	}

	return 'Страница'
}
